export default "__VITE_ASSET__8fe54500__"